module.exports = __webpack_public_path__ + "static/media/background-catering-hero.2fb58bb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background-catering-hero.jpg
// module id = 1584
// module chunks = 0